export default __webpack_public_path__ + "static/media/Marvel.a6c0f7d8.jpg";